import React from 'react';
import { useQuery } from '@apollo/client';
import { ProFormSelect } from '@ant-design/pro-form';
import { GET_FACULTIES } from '../../gql/faculties';

const ProSelectFaculty = ({ ...props }) => {
  const { data, loading } = useQuery(GET_FACULTIES);
  return (
    <ProFormSelect
      loading={loading}
      options={
        data
          ? data.faculties.map(({ id, name, abbreviation }) => ({
              value: id,
              label: `${abbreviation} - ${name}`,
            }))
          : []
      }
      {...props}
    />
  );
};

export default ProSelectFaculty;
